import SafetyHookListResultModelBase from '../_generated/modelBases/safety-hook-list-result-model-base';

export default class SafetyHookListResultModel extends SafetyHookListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
